//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/TaggedObject.js";
import "../no/Expression.js";
let d=[[[0,"Direction",1,"Direction",0],[1,"Distance",0,"Expression",0],[0,"EndcapOption",1,0],[0,"EndcapSource",1,0]],[[["targets"],"SetTargets",{},1,0],[["n_targets"],"GetTargets",{R_:{targets:"Features.EmbossTarget[]"}},0,0],[["distance"],"SetDistance",{},1,0]],[]];
SPLM.Features.EmbossLimit = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.EmbossLimit";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.EmbossLimit.EndcapMethod = Object.freeze({
    "Translation" : "Translation", "OffsetExact" : "OffsetExact", "OffsetApproximation" : "OffsetApproximation", "None" : "None"});

SPLM.Features.EmbossLimit.EndcapSourceOption = Object.freeze({
    "Target" : "Target", "Plane" : "Plane", "Section" : "Section", "Face" : "Face"});

export default SPLM;